import { IGetAllObraAreaChecklistUseCase } from "../../../presentation/useCases/read/get_all_obra_area_checklist_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { ObraAreaChecklist } from "../../models/obra_area_checklist";

/**
 * GetAllObraChecklistAreaUseCase
 */

export class GetAllObraAreaChecklistUseCase
  extends BasePaginatedUseCase<ObraAreaChecklist>
  implements IGetAllObraAreaChecklistUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObraAreaChecklist(
    idObra: number | undefined,
    area: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObra === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository.getAllObraAreaChecklist(
      idObra,
      area,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
